<template>
  <div>
    <button id="HistoryButton" @click="HistoryButtonAction" title="Vraćanje istorije">
      <p>
        <v-icon style="font-size:48px">keyboard_arrow_left</v-icon>
      </p>
    </button><!-- /#HistoryButton -->
  </div>
</template>
<script>
	import {serverBus} from "../../main";

	import EmptyTank from "./../EmptyTank";

	export default {
		name: "HistoryButton",
		dialog: false,
		data() {
			return {
				akcija: '1',
        // tank_phase_vineId: 0,
        idRoom: 0,
        naziv_prostorije: ""
			};
		},
		components: {
			EmptyTank: resolve => {
				setTimeout(() => {
					const component = EmptyTank;
					component.mixins = [];
					component.mixins.push(MountedMixin);
					resolve(component);
					// This could be the result of System.import of an async require
				}, 300);
			}
		},
		methods: {
			HistoryButtonAction(e) {
			  // alert(this.akcija);

				// // console.log(e);
				alert('Tank ima istoriju');
			},
// 			HistoryButtonAction(e) {

//         const Dialog__Content = document.getElementById("Dialog__Content--FloatingBtn"),
// 					Dialog__Overlay = document.getElementById("Dialog__Overlay--FloatingBtn");

// 				let vueInstance = this;
// 				let isOpen = false;

// let idRoomPom = this.$parent.idRoom;
// let akcijaPom = this.akcija;

// this.naziv_prostorije = this.$parent.nazivProstorije;

// 				function modalOpen() {
// 					if (!isOpen) {
// 						//// // console.log(e.target);
// 						if (e.target !== undefined) {
// 							vueInstance.$data.actionId = e.target.dataset.actionId;
// 						}

// 						Dialog__Content.style.display = "flex";
// 						Dialog__Content.classList += " v-dialog__content--active";
// 						Dialog__Overlay.style.display = "block";
// 						Dialog__Overlay.classList += " v-overlay--active";

//         if (akcijaPom == 1) {
//           serverBus.$emit("room");
//           serverBus.$emit("room_item", idRoomPom);
// 				}
// 				else if (akcijaPom == 2) {

//           // alert(654321);
//           // alert(this.idRoom);
//           serverBus.$emit("tank", idRoomPom);
//           serverBus.$emit("tank_item", idRoomPom);
//         }
        
        
          
          
//             isOpen = true;
            
// 					}
// 				}

// 				function modalClose() {
// 					// serverBus.$off("room");
// 					// serverBus.$off("tank");
// 					// serverBus.$off("tank_item");

// 					Dialog__Content.style.display = "none";
// 					Dialog__Content.classList.remove("v-dialog__content--active");
// 					Dialog__Overlay.style.display = "none";
// 					Dialog__Overlay.classList.remove("v-overlay--active");

// 					isOpen = false;

// 					// alert("maka");
// 					serverBus.$emit("osvezi_meni");
// 					serverBus.$emit("ucitaj_podatke");
// 				}

// 				if (e.target !== undefined) {
// 					if (e.target.nodeName !== "UL" && e.target.nodeName !== "DIV") {

// 					}

// 					/**
// 					 * Close Modal
// 					 */
// 					if (e.target.id === "closeModalBtn") {
// 						modalClose();
// 					}
// 					else {
// 						/**
// 						 * Open Modal
// 						 */
// 						modalOpen();
// 					}

// 				} else {
// 					alert(e);
// 				}

// 			},
			customMounted() {

			}
		},
		// mounted() {
    //   serverBus.$off("room");
    //   serverBus.$off("room_item");
		// 	serverBus.$off("tank");
		// 	serverBus.$off("tank_item");
      
    //   this.akcija = this.$parent.floating_akcija;
      
    //   serverBus.$on('fb', (idRoom) => {
		// 		this.idRoom = idRoom;
		// 	});
		// }
	};
</script>
<style scoped lang='scss'>
  @import "./../parts/../../assets/sass/parts/modalStyles";
  
  #HistoryButton {
    position: fixed;
    right: 10px;
    bottom: 20px;
    width: 54px;
    height: 54px;
    font-size: 40px;
    border-radius: 50%;
    color: #ffffff;
    background-color: #018389;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    transition: .2s ease-in-out;
    p {
      position: relative;
      width: 100%;
      height: 100%;
      i {
        // position: absolute;
        // left: 15px;
        // top: 15px;
        // transform: rotate(45deg);
        color: #ffffff;
      }
    }
    &:active, &:focus {
      box-shadow: none;
    }
  }
</style>